/* Partify Fitment Card � matches Figma mockup */
(function () {
	"use strict";

	var ICONS = {
		success:
			'<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="#16a34a"/><path d="M10 20l7.5 7.5L30 12.5" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
		fail: '<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="#dc2626"/><path d="M12.5 12.5l15 15M27.5 12.5l-15 15" stroke="#fff" stroke-width="3" stroke-linecap="round"/></svg>',
		warn: '<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="#d97706"/><path d="M20 11v11" stroke="#fff" stroke-width="3" stroke-linecap="round"/><circle cx="20" cy="28.5" r="2.2" fill="#fff"/></svg>',
		loading:
			'<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="16" stroke="#e5e7eb" stroke-width="2.5"/><path d="M20 4a16 16 0 0 1 16 16" stroke="#d97706" stroke-width="2.5" stroke-linecap="round"/></svg>',
	};

	var _submodelDismissed = false; /* kept for API compat — dismiss flow removed */

	function getVehicle() {
		try {
			var a = JSON.parse(localStorage.getItem("searchTerms") || "[]");
			return Array.isArray(a) && a.length && a[0].model ? a[0] : null;
		} catch (_) {
			return null;
		}
	}

	function fmt(v) {
		return v
			? [v.year, v.make, v.model, v.submodel, v.engine]
					.filter(Boolean)
					.join(" ")
			: "";
	}

	function openGarage() {
		var b =
			document.querySelector("[data-gv2-open]") ||
			document.querySelector(".garage-modal-v2-open-btn") ||
			document.querySelector('[aria-label="Garage"]');
		if (b) {
			b.click();
			return;
		}
		if (typeof window.toggleGaragePopup === "function") {
			window.toggleGaragePopup();
			return;
		}
		var h = document.querySelector(
			".site-header__icon--garage, .header__garage-btn",
		);
		if (h) h.click();
	}

	/* Parse keystone_description */
	function parseKeystone(raw) {
		if (!raw) return { bullets: [], rows: [] };
		var bullets = [],
			rows = [];
		raw
			.split(/\u2022|\u00b7|<br\s*\/?>|\n/)
			.map(function (s) {
				return s.replace(/<[^>]*>/g, "").trim();
			})
			.filter(Boolean)
			.forEach(function (p) {
				var lo = p.toLowerCase();
				if (lo.indexOf("replaces:") === 0 || lo.indexOf("replaces :") === 0) {
					rows.push({
						label: "OEM Cross-References:",
						value: "\u2022 Replaces: " + p.replace(/^replaces\s*:\s*/i, ""),
					});
				} else if (
					lo.indexOf("partslink:") === 0 ||
					lo.indexOf("partslink :") === 0
				) {
					var ex = rows.filter(function (r) {
						return r.label === "OEM Cross-References:";
					})[0];
					if (ex)
						ex.value +=
							"\n\u2022 Partslink: " + p.replace(/^partslink\s*:\s*/i, "");
					else
						rows.push({
							label: "OEM Cross-References:",
							value: "\u2022 Partslink: " + p.replace(/^partslink\s*:\s*/i, ""),
						});
				} else if (
					lo.indexOf("not compatible") > -1 ||
					lo.indexOf("compatible with") > -1 ||
					lo.indexOf("standard edition") > -1 ||
					lo.indexOf("with fog") > -1 ||
					lo.indexOf("without fog") > -1 ||
					lo.indexOf("fitment note") > -1
				) {
					var en = rows.filter(function (r) {
						return r.label === "Fitment Notes:";
					})[0];
					if (en) en.value += "\n\u2022 " + p;
					else rows.push({ label: "Fitment Notes:", value: "\u2022 " + p });
				} else {
					var ci = p.indexOf(":");
					if (ci > 0 && ci < 40)
						bullets.push(
							"<strong>" +
								p.substring(0, ci).trim() +
								":</strong> " +
								p.substring(ci + 1).trim(),
						);
					else bullets.push(p);
				}
			});
		return { bullets: bullets, rows: rows };
	}

	function renderDetails(card, show) {
		var el = card.querySelector("[data-pfc-details]");
		if (!el) return;
		if (!show) {
			el.hidden = true;
			return;
		}
		var raw = card.getAttribute("data-pfc-keystone") || "";
		var pl = card.getAttribute("data-pfc-partslink") || "";
		var d = parseKeystone(raw);
		if (
			pl &&
			!d.rows.some(function (r) {
				return r.value.indexOf(pl) > -1;
			})
		) {
			var oe = d.rows.filter(function (r) {
				return r.label === "OEM Cross-References:";
			})[0];
			if (oe) oe.value += "\n\u2022 Partslink: " + pl;
			else
				d.rows.unshift({
					label: "OEM Cross-References:",
					value: "\u2022 Partslink: " + pl,
				});
		}
		if (!d.bullets.length && !d.rows.length) {
			el.hidden = true;
			return;
		}
		var li = card.querySelector("[data-pfc-details-list]");
		var tb = card.querySelector("[data-pfc-details-table]");
		if (li)
			li.innerHTML = d.bullets
				.map(function (b) {
					return "<li>" + b + "</li>";
				})
				.join("");
		if (tb)
			tb.innerHTML = d.rows
				.map(function (r) {
					return (
						"<tr><td>" +
						r.label +
						"</td><td>" +
						r.value.split("\n").join("<br>") +
						"</td></tr>"
					);
				})
				.join("");
		el.hidden = false;
	}

	function vehicleCollectionUrl(ymm) {
		if (!ymm) return null;
		var handle = ymm
			.toLowerCase()
			.replace(/[./+:]/g, "-")
			.replace(/\s+/g, "-")
			.replace(/[^\w-]+/g, "")
			.replace(/--+/g, "-")
			.replace(/^-+|-+$/g, "");
		if (!handle) return null;
		var configuredRoot =
			window.Shopify && window.Shopify.routes
				? String(window.Shopify.routes.root || "").trim()
				: "";
		var normalizedRoot = configuredRoot.replace(/^\/+|\/+$/g, "");
		var routeRoot = normalizedRoot ? "/" + normalizedRoot + "/" : "/";
		return routeRoot + "collections/" + handle;
	}

	function recordVehicleCollectionRecovery(url, vehicle) {
		try {
			var recovery = window.PartifyVehicleCollectionRecovery;
			if (recovery && typeof recovery.record === "function") {
				recovery.record(url, vehicle);
			}
		} catch (_error) {}
	}

	async function collectionExists(url) {
		try {
			var response = await fetch(url, {
				method: "HEAD",
				credentials: "same-origin",
			});
			return response.ok;
		} catch (_error) {
			return false;
		}
	}

	async function navigateToVehicleCollection(vehicle) {
		if (!vehicle) {
			openGarage();
			return;
		}
		var year = String(vehicle.year || "").trim();
		var make = String(vehicle.make || "").trim();
		var model = String(vehicle.model || "").trim();
		var broadYmm = year && make && model ? [year, make, model].join(" ") : "";
		var detailedYmm =
			String(vehicle.fitmentYmm || "").trim() ||
			String(vehicle.ymm || "").trim() ||
			broadYmm;
		var detailedUrl = vehicleCollectionUrl(detailedYmm);
		var broadUrl = vehicleCollectionUrl(broadYmm);
		if (!detailedUrl) {
			openGarage();
			return;
		}
		if (!broadUrl || detailedUrl === broadUrl) {
			if (!broadUrl || (await collectionExists(detailedUrl))) {
				window.location.href = detailedUrl;
				return;
			}
			recordVehicleCollectionRecovery(detailedUrl, vehicle);
			window.location.href = detailedUrl;
			return;
		}
		if (await collectionExists(detailedUrl)) {
			window.location.href = detailedUrl;
			return;
		}
		if (await collectionExists(broadUrl)) {
			window.location.href = broadUrl;
			return;
		}
		recordVehicleCollectionRecovery(broadUrl, vehicle);
		window.location.href = broadUrl;
	}

	function checkSubmodelGate(v, req) {
		if (!req) return "ok";
		if (!v) return "no-vehicle";
		var hasSub = !!(v.submodel && String(v.submodel).trim());
		return hasSub ? "ok" : "missing-submodel";
	}

	function render(card, state, vehicle) {
		card.setAttribute("data-pfc-state", state);
		var ic = card.querySelector("[data-pfc-icon]");
		var lb = card.querySelector("[data-pfc-label]");
		var ve = card.querySelector("[data-pfc-vehicle]");
		var ch = card.querySelector("[data-pfc-change]");
		var sc = card.querySelector("[data-pfc-secondary]");
		var bd = card.querySelector("[data-pfc-body]");
		var vl = vehicle ? fmt(vehicle) : "";

		/* Reset button visibility; individual states override as needed */
		if (sc) {
			sc.hidden = false;
			sc.onclick = null;
		}
		if (bd) {
			bd.textContent = "";
			bd.hidden = true;
		}

		if (state === "success") {
			if (ic) ic.innerHTML = ICONS.success;
			if (lb) lb.textContent = "CONFIRMED FIT:";
			if (ve) ve.textContent = vl || "your vehicle";
			if (ch) ch.textContent = "Change Vehicle";
			if (sc) {
				sc.textContent = "View Other Parts";
				sc.onclick = function () {
					navigateToVehicleCollection(vehicle);
				};
			}
			renderDetails(card, true);
		} else if (state === "fail") {
			if (ic) ic.innerHTML = ICONS.fail;
			if (lb) lb.textContent = "DOES NOT FIT:";
			if (ve) ve.textContent = vl || "your vehicle";
			if (ch) ch.textContent = "Change Vehicle";
			if (sc) {
				sc.textContent = "View Other Parts";
				sc.onclick = function () {
					navigateToVehicleCollection(vehicle);
				};
			}
			renderDetails(card, false);
		} else if (state === "warn-submodel") {
			if (ic) ic.innerHTML = ICONS.warn;
			if (lb) lb.textContent = "SUBMODEL REQUIRED";
			if (ve) ve.textContent = vl || "your vehicle";
			if (ch) ch.textContent = "Update My Vehicle";
			if (sc) sc.hidden = true;
			if (bd) {
				bd.textContent =
					"This part requires a specific submodel. Your saved vehicle is missing one.";
				bd.hidden = false;
			}
			renderDetails(card, false);
		} else if (state === "no-vehicle") {
			if (ic) ic.innerHTML = ICONS.warn;
			if (lb) lb.textContent = "CHECK FITMENT";
			if (ve) ve.textContent = "";
			if (ch) ch.textContent = "Add Vehicle";
			if (sc) {
				sc.textContent = "View Other Parts";
				sc.onclick = openGarage;
			}
			var _rawReq = card.getAttribute("data-pfc-submodel-req") || "";
			var _req =
				_rawReq === "true" || _rawReq.replace(/"/g, "").trim() === "true";
			if (bd && _req) {
				bd.textContent =
					"This part requires a specific submodel for fitment confirmation.";
				bd.hidden = false;
			}
			renderDetails(card, false);
		} else {
			if (ic) ic.innerHTML = ICONS.loading;
			if (lb) lb.textContent = "Checking fitment\u2026";
			if (ve) ve.textContent = "";
			renderDetails(card, false);
		}
	}

	function resolveAndRender(card) {
		var rawReq = card.getAttribute("data-pfc-submodel-req") || "";
		var req = rawReq === "true" || rawReq.replace(/"/g, "").trim() === "true";
		window.partifySubmodelRequired = req; /* expose for garage modal */
		var v = getVehicle();

		if (!v) {
			render(card, "no-vehicle", null);
			return;
		}

		/* Resolve actual fitment first so we never show warn-submodel for a
		   non-fitting vehicle (e.g. 2005 Ford Escape on a Ram 1500 bumper) */
		var fitState = null;
		var fitReason = null;
		if (
			window.__PARTIFY_NATIVE_FITMENT === "primary" &&
			window.PartifyFitment
		) {
			var r = window.PartifyFitment.resolve();
			fitState = r ? r.state : "no-vehicle";
			fitReason = r ? r.reason : null;
		} else if (
			window.PartifyAdapter &&
			typeof window.PartifyAdapter.getFitmentStateFromDOM === "function"
		) {
			var dr = window.PartifyAdapter.getFitmentStateFromDOM();
			if (dr && dr.state !== "unknown") fitState = dr.state;
		}

		/* Only gate on submodel when the vehicle fits (or fitment is still loading) */
		if (
			req &&
			(fitState !== "fail" || fitReason === "missing-specificity") &&
			checkSubmodelGate(v, req) === "missing-submodel"
		) {
			render(card, "warn-submodel", v);
			/* Lock Quality Options / Paint / ATC — same as a fitment fail */
			document.dispatchEvent(
				new CustomEvent("partify:native-fitment-resolved", {
					detail: { state: "fail", vehicle: v },
				}),
			);
			if (window.PartifyAdapter && window.PartifyAdapter.emitFitmentState) {
				window.PartifyAdapter.emitFitmentState("fail", v);
			}
			return;
		}

		/* Normal fitment path */
		if (fitState) {
			render(card, fitState, v);
			return;
		}

		/* Still loading (EasySearch MutationObserver path) */
		render(card, "loading", v);
		var ct = document.querySelector(".model-fitment-easysearch-container");
		if (ct) {
			var ob = new MutationObserver(function () {
				ob.disconnect();
				resolveAndRender(card);
			});
			ob.observe(ct, { childList: true, subtree: true });
			setTimeout(function () {
				ob.disconnect();
				resolveAndRender(card);
			}, 4000);
		}
	}

	function init() {
		var card = document.querySelector("[data-partify-fitment-card]");
		if (!card) return;
		card
			.querySelector("[data-pfc-change]")
			.addEventListener("click", function () {
				if (card.getAttribute("data-pfc-state") === "warn-submodel") {
					if (window.GarageV2 && window.GarageV2.openAndFocusSubmodel) {
						window.GarageV2.openAndFocusSubmodel();
					} else {
						openGarage();
					}
				} else {
					openGarage();
				}
			});
		resolveAndRender(card);
		document.addEventListener("partify:vehicle:changed", function () {
			setTimeout(function () {
				resolveAndRender(card);
			}, 100);
		});
		window.addEventListener("searchTermsUpdated", function () {
			setTimeout(function () {
				resolveAndRender(card);
			}, 100);
		});
	}

	if (document.readyState === "loading")
		document.addEventListener("DOMContentLoaded", init);
	else init();
})();
